import cn from 'classnames';
import type { FC, PropsWithChildren } from 'react';

import styles from './FindingChip.module.scss';

/**
 * Colour of the pill. `neutral` is the resting grey used when a row should not draw attention,
 * so the same counts can be shown muted or coloured depending on their surroundings.
 */
export type FindingTone = 'critical' | 'warning' | 'info' | 'neutral';

interface FindingChipProps {
  tone: FindingTone;
  className?: string;
  testId?: string;
}

/** A single pill in a run's severity breakdown, coloured by tone. */
const FindingChip: FC<PropsWithChildren<FindingChipProps>> = ({ tone, children, className, testId }) => (
  <span
    className={cn(styles.chip, styles[tone], className)}
    data-test-component="FindingChip"
    data-test-element="chip"
    data-test-key={tone}
    data-testid={testId}
  >
    {children}
  </span>
);

export default FindingChip;
